module.exports = __webpack_public_path__ + "src/assets/img/map_select.64dbb94d.svg";